var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"tree-types"},[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Tree Types")])])],1),_c('TreeTypeListComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }